import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { SimpleTabContentProp } from "../../../../Types/UiKitsType";
import { Container, Card, Col, Row, CardBody } from "reactstrap";

import { ViewCompanyProfile } from "../../../../Types/CompanyProfile/CompanyProfile";
import OpsStructureTable from "../../../DataTables/DeploymentSite/StructureTable";
import ClusterTable from "../../../DataTables/Cluster/ClusterTable";
import DeploymentSiteTable from "../../../DataTables/DeploymentSite/DeploymentSiteTable";

type CompanyDataProps = {
  companyInfo?: ViewCompanyProfile;
  tabId: string;
};

const PillTabContent: React.FC<CompanyDataProps> = ({ tabId, companyInfo }) => {
  return (
    <TabContent activeTab={tabId}>
      <TabPane tabId={"1"} className={`fade ${tabId === "1" ? "show" : ""}`}>
        <Col sm="12">
          <OpsStructureTable companyInfo={companyInfo} />
        </Col>
      </TabPane>
      <TabPane tabId={"2"} className={`fade ${tabId === "2" ? "show" : ""}`}>
        <Col sm="12">
          <ClusterTable companyInfo={companyInfo} />
        </Col>
      </TabPane>
      <TabPane tabId={"3"} className={`fade ${tabId === "3" ? "show" : ""}`}>
        <Col sm="12">
          <DeploymentSiteTable companyInfo={companyInfo} />
        </Col>
      </TabPane>
    </TabContent>
  );
};
export default PillTabContent;
